import type React from "react";
import AlertBanner from "../../../../components/Banner/AlertBanner";
import type { DefinitionWarning } from "./padSerialNumber";

interface RowWithWarnings {
  warnings?: DefinitionWarning[];
}

function countSerialCleanups(definitions: RowWithWarnings[]): {
  apostrophes: number;
  whitespace: number;
} {
  const counts = { apostrophes: 0, whitespace: 0 };
  for (const def of definitions) {
    const message = def.warnings?.find(
      (w) => w.field === "serial_number",
    )?.warning;
    if (!message) continue;
    if (message.includes("Apostrophes")) counts.apostrophes += 1;
    if (message.includes("whitespace")) counts.whitespace += 1;
  }
  return counts;
}

function describeCleanup(counts: {
  apostrophes: number;
  whitespace: number;
}): string | null {
  const parts: string[] = [];
  if (counts.apostrophes > 0) {
    parts.push(
      `${counts.apostrophes} row${
        counts.apostrophes === 1 ? "" : "s"
      } had apostrophes removed`,
    );
  }
  if (counts.whitespace > 0) {
    parts.push(
      `${counts.whitespace} row${
        counts.whitespace === 1 ? "" : "s"
      } had surrounding whitespace trimmed`,
    );
  }
  if (parts.length === 0) return null;
  return parts.join("; ");
}

export default function CleanupWarningBanner(props: {
  definitions: RowWithWarnings[];
}): React.ReactElement {
  const cleanup = describeCleanup(countSerialCleanups(props.definitions));
  if (!cleanup) return <></>;
  return (
    <AlertBanner margin={3}>
      Some serial numbers were cleaned automatically: {cleanup}.
    </AlertBanner>
  );
}
